<template>
  <div class="video"
       ref="wrapper"
       :class="isShowControls && !isFullScreen ? 'video_bg' : ''"
       @click="clickToVideo"
       @mouseover="showControls"
       @mouseleave="hideControls">
    <div class="video__video" ref="videoWrap" :style="getWrapperStyles">
      <div :style="getVideoStyles" class="video__container" ref="videoContainer">
        <video ref="video"
               class="video__item"
               :class="[videoSet.current.z > 1 ? 'video__item_grab' : '',
                   countTap === 2 ? 'video__item_translate' : '',
                   isFullScreen ? 'video__item_fullscreen' : '']"
               playsinline autoplay muted></video>
        <div class="video__filter-container" :style="getFilterStyles">
          <filter-object
              v-if="mut.height != null"
              :height="mut.height"
              :width="mut.width"
              :left="mut.left"
              :top="mut.top"
              :is-round="mut.isRound"/>
          <p class="watermark" v-if="!isLoading">id{{$store.getters.PROFILE._id}}</p>
        </div>

      </div>
      <video-interface
          v-if="isFullScreen"
          :video="video"
          :hasAudio="hasAudio"
          :stop="stop"
          :zoom="videoSet.current.z"
          :volume="volume"
          @changePlay="changePlay"
          @changeZoom="changeZoom"
          @exitScreen="exitScreen"
          @changeVolume="changeVolume"
          @mouseenter.native="disablePan"
          @mouseleave.native="enablePan"
      ></video-interface>
    </div>
    <div class="video__loader" v-if="isLoading">
      <video-loader></video-loader>
    </div>
    <svg
        v-if="isMuted && hasAudio"
        @click="changeVolume(1)"
        class="volume__icon"
        width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Главная /1 блок/звук/выкл</title>
      <g id="Главная-/1-блок/звук/выкл" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="#000000" opacity="0.796670603" cx="13" cy="13" r="13"></circle>
        <g id="Group" transform="translate(6.000004, 8.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <path d="M2.119,3.07 L6.999,8.004 L6.99984962,9.35504834 C6.99984962,9.60524379 6.85743748,9.83254155 6.63457077,9.93863419 C6.54840165,9.98000268 6.45606686,10 6.36433359,10 C6.21906419,10 6.07514823,9.94931978 5.95890264,9.85147031 L2.48536994,6.92972481 L0.635365644,6.92972481 C0.284523503,6.93003012 0,6.64106125 0,6.28492581 L0,3.71534682 C0,3.35905874 0.284523503,3.07024251 0.635365644,3.07024251 L2.119,3.07 Z M6.63472115,0.0616384464 C6.85743748,0.167731086 7,0.395181492 7,0.645224288 L6.999,6.039 L3.347,2.345 L5.95905302,0.148497024 C6.14883561,-0.0111762139 6.41200481,-0.0452174492 6.63472115,0.0616384464 Z" id="Combined-Shape"></path>
          <path d="M0.425612476,0.404083516 C0.559472963,0.288757552 0.759053459,0.269127989 0.914898787,0.345850897 L0.914898787,0.345850897 L0.985996434,0.391 L1.03931627,0.438243492 L9.59726611,9.09210082 L9.64443706,9.15026372 C9.73765082,9.29261829 9.71307653,9.47642442 9.57438039,9.59591648 C9.41820982,9.73046344 9.17258702,9.73475696 9.01132275,9.60775524 L9.01132275,9.60775524 L8.9606766,9.56175651 L0.40272676,0.907899175 L0.355555805,0.849736281 C0.262342047,0.707381713 0.286916334,0.523575583 0.425612476,0.404083516 Z" id="Combined-Shape"></path>
        </g>
      </g>
    </svg>
    <svg
        v-else-if="!isMuted && hasAudio"
        @click="changeVolume(0)"
        class="volume__icon"
        width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Главная /1 блок/звук/вкл</title>
      <g id="Главная-/1-блок/звук/вкл" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="#000000" opacity="0.796670603" cx="13" cy="13" r="13"></circle>
        <path d="M12.6347211,8.06163845 C12.8574375,8.16773109 13,8.39518149 13,8.64522429 L12.9998496,17.3550483 C12.9998496,17.6052438 12.8574375,17.8325415 12.6345708,17.9386342 C12.5484016,17.9800027 12.4560669,18 12.3643336,18 C12.2190642,18 12.0751482,17.9493198 11.9589026,17.8514703 L8.48536994,14.9297248 L6.63536564,14.9297248 C6.2845235,14.9300301 6,14.6410612 6,14.2849258 L6,11.7153468 C6,11.3590587 6.2845235,11.0702425 6.63536564,11.0702425 L8.48552032,11.0702425 L11.959053,8.14849702 C12.1488356,7.98882379 12.4120048,7.95478255 12.6347211,8.06163845 Z M17.355774,8.00031347 C17.5397986,8.00477834 17.7138545,8.07432208 17.8361683,8.1920323 C19.2314638,9.53528185 19.9999999,11.2657575 19.9999999,13.0641532 C20.0003163,14.7944935 19.2817818,16.4754496 17.9768371,17.7971866 C17.8559474,17.9193617 17.6811003,17.9926938 17.4939111,17.9994588 C17.4847336,17.9997294 17.4753979,18 17.4659039,18 C17.2888416,18 17.1188997,17.9401978 16.9931047,17.832635 L16.9052856,17.757544 C16.6598668,17.5478304 16.6432524,17.2124239 16.8663604,16.985392 C17.9445577,15.888928 18.538563,14.4964296 18.538563,13.0641532 C18.538563,11.5743747 17.902626,10.1402042 16.7483188,9.02588071 C16.5142927,8.7996606 16.5261602,8.45721856 16.7752184,8.24344596 L16.8628793,8.16835496 C16.9929465,8.05659789 17.161939,7.9950368 17.355774,8.00031347 Z M15.0767491,10.3546834 C15.2653624,10.3613698 15.4414754,10.4238871 15.5610993,10.5268569 C16.3486232,11.2055211 16.7646168,12.029502 16.7646168,12.9094253 C16.7646168,13.7289486 16.3967259,14.5090224 15.7005022,15.1649531 C15.5842012,15.2742749 15.4063477,15.3429213 15.2128292,15.3526166 C15.1965312,15.3533966 15.1808662,15.3538424 15.1647265,15.3538424 C14.9881388,15.3538424 14.8178805,15.3046977 14.6920856,15.2159922 L14.6026841,15.1528062 C14.3681833,14.9879877 14.3406508,14.7268859 14.5381252,14.5394453 C15.0387733,14.064046 15.3030218,13.5004984 15.3030218,12.9093138 C15.3030218,12.2734422 15.0030127,11.67702 14.435274,11.1844591 C14.2191282,10.9972414 14.2390655,10.7253299 14.4813197,10.5548281 L14.5705629,10.491865 C14.7041112,10.3978104 14.8830724,10.3465484 15.0767491,10.3546834 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
      </g>
    </svg>
    <svg
        class="video__fullscreen"
        @click="goToFullSize"
        width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Главная /1 блок/трансляция просто/трансляция/инструменты/десктоп во весь экран</title>
      <g id="Главная-/1-блок/трансляция-просто/трансляция/инструменты/десктоп-во-весь-экран" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" fill="#000000" opacity="0.796670603" cx="13" cy="13" r="13"></circle>
        <path d="M7.28571429,15.2857143 L5,15.2857143 L5,21 L10.7142857,21 L10.7142857,18.7142857 L7.28571429,18.7142857 L7.28571429,15.2857143 L7.28571429,15.2857143 Z M5,10.7142857 L7.28571429,10.7142857 L7.28571429,7.28571429 L10.7142857,7.28571429 L10.7142857,5 L5,5 L5,10.7142857 L5,10.7142857 Z M18.7142857,18.7142857 L15.2857143,18.7142857 L15.2857143,21 L21,21 L21,15.2857143 L18.7142857,15.2857143 L18.7142857,18.7142857 L18.7142857,18.7142857 Z M15.2857143,5 L15.2857143,7.28571429 L18.7142857,7.28571429 L18.7142857,10.7142857 L21,10.7142857 L21,5 L15.2857143,5 L15.2857143,5 Z" id="Fill-202" fill="#FFFFFF"></path>
      </g>
    </svg>
  </div>
</template>

<script>
import * as Hls from 'hls.js'
import VideoInterface from "./VideoInterface";
import VideoLoader from "@/components/loader/VideoLoader";
import FilterObject from "@/components/FilterObject";
import ResizeObserver from 'resize-observer-polyfill';
import * as panzoom from "panzoom"



export default {
  name: "VideoItem",
  components: {FilterObject, VideoLoader, VideoInterface},
  props: {
    video: Object,
    frame: Object,
    type: String,
    schid: Number
  },
  data() {
    return {
      volume: 0,
      zoom: 1,
      mut: {},
      isLoading: true,
      clickToView: false,
      hasAudio: null,
      isMuted: true,
      isShowControls: false,
      stop: false,
      showError: false,
      isFullScreen: false,
      desktopZoomInstance: null,
      isMobile: null,
      countTap: 0,
      position: {
        top: 0,
        bottom: 0
      },
      isIos: false,
      videoSet: {
        pinchStart: {
          x: 0,
          y: 0,
        },
        originalSize: {
          width: 0,
          height: 0
        },
        current: {
          x: 0,
          y: 0,
          z: 1,
          zooming: false,
          width: 0,
          height: 0
        },
        last: {
          x: 0,
          y: 0,
          z: 1
        },
        type: undefined,
        delta: {x: undefined, y: undefined}
      },
      filterContainerStyle:{
        width: 0,
        height: 0
      },
    }
  },
  computed: {
    getScale() {
      return this.videoSet.current.z
    },
    getVideoStyles() {
      if (this.isFullScreen) {
        if (this.videoSet.current.z !== 1 && this.isMobile) {
          return {
            'transform': 'translate3d(' + this.videoSet.current.x + 'px,' + this.videoSet.current.y + 'px, 0) scale(' + this.videoSet.current.z + ')'
          }
        }

      }
      return {'transform': 'translate3d(0,0,0) scale(1)'}
    },
    getWrapperStyles() {
      if (this.isIos && this.isFullScreen) {
        return {
          position: 'fixed',
          top: '0',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '100%',
          'z-index': 100,
          background: '#000'
        }
      }
      return {}
    },
    getShow() {
      return true
    },
    getVolume() {
      return this.volume
    },

    getFilterStyles(){
      return this.filterContainerStyle
    }
  },
  methods: {
    disablePan(){
      this.desktopZoomInstance.pause();
    },
    enablePan(){
      this.desktopZoomInstance.resume();
    },
    changeTap() {
      if (this.$windowWidth < 993 && this.isFullScreen && this.videoSet.current.z > 1) {
        this.countTap++
      }
    },


    changeVolume(size) {
      this.volume = size
      this.toggleMute(size)
      this.$refs.video.volume = size
    },
    computedFilterObject(){
      let video = this.$refs.video
      if (video == null) return {}
      this.filterContainerStyle = {...{
          height : video.clientHeight + 'px',
          width: video.clientWidth + 'px',
          position: 'absolute',
        }}

      if (this.video.blurPreference == null) return {}

      const xcoef = video.clientWidth/this.video.blurPreference.cw
      const ycoef = video.clientHeight/this.video.blurPreference.ch
      const coef = (xcoef+ycoef)/2
      const obj ={
        top: `${this.video.blurPreference.y*ycoef}px`,
        left: `${this.video.blurPreference.x*xcoef}px`,
        width: `${this.video.blurPreference.w*xcoef}px`,
        height: `${this.video.blurPreference.h*ycoef}px`,
        isRound: this.video.blurPreference.isRound
      }
      return obj;
    },
    loadShow() {
      const video = this.$refs.wrapper.parentNode
      this.position.top = video.offsetTop
      this.position.bottom = this.position.top + video.clientHeight
    },
    generateVideo() {
      const video = this.$refs.video
      this.hlsPlayer = new Hls({
        liveBackBufferLength: 5,
        backBufferLength: 5,
        liveMaxBackBufferLength: 5,
        maxBufferSize: 30,
        maxBufferLength: 5,
        capLevelToPlayerSize: true,
        liveSyncDurationCount: 1
      })
      video.volume = 0
      if (Hls.isSupported()) {
        this.hlsPlayer.on('hlsFragChanged', (e, data) => {
          const range = {
            startOffset: 0,
            endOffset: data.frag.startDTS
          }
          this.hlsPlayer.trigger('hlsBufferFlushing', range)
        })
      }
    },
    playVideo() {
      const video = this.$refs.video
      this.isLoading = true
      video.muted=true
      this.isMuted = true

      this.videoSet.originalSize = {
        width: this.$refs.video.clientWidth,
        height: this.$refs.video.clientHeight
      }

      if (Hls.isSupported()) {
        this.hlsPlayer.loadSource(this.video.uri)
        this.hlsPlayer.attachMedia(video)
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.video.uri
      }

      video.addEventListener('waiting', () => {
        this.isLoading = true
      }, false)

      video.addEventListener('playing', () => {
        if (typeof video.webkitAudioDecodedByteCount !== 'undefined') {
          if (video.webkitAudioDecodedByteCount > 0) this.hasAudio = true
          else this.hasAudio = false
        } else if (typeof video.mozHasAudio !== 'undefined') {
          if (video.mozHasAudio) this.hasAudio = true
          else this.hasAudio = false
        } else if (typeof video.audioTracks !== 'undefined') {
          if (video.audioTracks && video.audioTracks.length) this.hasAudio = true
          else this.hasAudio = false
        } else {
          this.hasAudio = false
        }
        //this.isLoading = false
      }, false)

      video.addEventListener('loadstart', (e) => {
        if (e.target.paused) {
          //this.isLoading = false
        } else {
          this.isLoading = true
        }
      }, false)

      video.addEventListener('error', () => {
        this.isLoading = false
      }, false)

      video.addEventListener('timeupdate', () => {
        this.isLoading = false
      }, false)

      video.addEventListener('webkitendfullscreen', () => {
        setTimeout(() => {
          video.play()
        }, 1500)
      }, false)
    },
    toggleMute(size) {
      const isMuted = !(size > 0)
      this.isMuted = isMuted
      this.$refs.video.muted = isMuted
      this.$emit("changeMute",this.isMuted)
    },
    mute(){
      this.isMuted = true
      this.$refs.video.muted = true
    },
    async goToFullSize() {
      await this.$store.dispatch("changeFullScreen",{isFullscreen: 1,type: this.type,scheduleInfo: this.schid })
      await this.$emit("changeFullscreen",!this.isFullScreen)
      const e = this.$refs.videoWrap
      if ((!this.isIos || (this.isIos && !this.isMobile))) {
        if (e.requestFullscreen) {
          await e.requestFullscreen()
        } else if (e.mozRequestFullScreen) {
          await e.mozRequestFullScreen()
        } else if (e.webkitRequestFullScreen) {
          await e.webkitRequestFullScreen()
        }
      }
      this.isFullScreen = true
    },
    showControls(el) {
      if (this.$windowWidth > 992) {
        // const classes = el.target.parentNode.classList
        // let classInVideo = false
        // for (let item of classes) {
        //   console.log(item)
        //   if (item.indexOf('video') !== -1) {
        //     classInVideo = true
        //   }
        // }
        // console.log(el,classInVideo)
        // if (classInVideo) {
        //   this.isShowControls = true
        // } else {
        //   this.isShowControls = false
        // }
          this.isShowControls = true

      }
    },
    hideControls(el) {
      if (el.type === 'mouseover' || el.type === 'mouseleave') {
        this.isShowControls = false
      }
    },
    clickToVideo(e) {
      if (this.$windowWidth < 993) {
        console.log(e)
        const classes = e.target.parentNode.classList
        let classInVideo = false
        for (let item of classes) {
          console.log(item)
          if (item.indexOf('video') !== -1) {
            classInVideo = true
          }
        }
        console.log(e,classInVideo)
        if (classInVideo) {
          this.goToFullSize()
        } else {
        }
      }
    },
    changeFullScreen() {
      if (!(document.fullscreenElement || document.webkitCurrentFullScreenElement)) {
        this.exitScreen()
        this.$emit("changeFullscreen",this.isFullScreen)
      }
    },
    changePlay(type) {
      return this.stop = type
    },
    changeZoom(e) {
      var x = window.innerWidth / 2;
      var y = window.innerHeight / 2;
      this.videoSet.current.z = 1
      this.desktopZoomInstance.smoothZoom(x, y, 0);
    },
    async exitScreen() {
      await this.$store.dispatch("changeFullScreen",{isFullscreen: 0,type: this.type })
      if (!this.isIos || (this.isIos && !this.isMobile)){
        if (document.exitFullscreen) {
          await document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          await document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          await document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          await document.msExitFullscreen();
        }
      }
      this.isFullScreen = false

      this.$refs.videoContainer.style.transform = null
      this.desktopZoomInstance.zoomTo(0,0,0)
      this.$emit("changeFullscreen",this.isFullScreen)

    },
    stopVideo(){
      if (this.hlsPlayer != null){
        console.log(this.hlsPlayer)
        this.hlsPlayer.detachMedia();
      }
    },

    fullStop(){
      if (this.hlsPlayer != null){
        this.hlsPlayer.destroy()
      }
    }

  },
  mounted() {
    this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    this.isIos = this.$refs.video.canPlayType('application/vnd.apple.mpegurl')
    this.isLoading = true

    this.generateVideo()
    this.playVideo()

    const ro = new ResizeObserver(entries => {
      if (this.videoSet.current.z === 1){
        this.mut = {...this.computedFilterObject()}
      }
    });

    ro.observe(this.$refs.video);
  },
  watch: {
    getScale() {
      if (this.videoSet.current.z <= 1) {
        this.videoSet.current.z = 1
        this.videoSet = {
          pinchStart: {
            x: 0,
            y: 0,
          },
          originalSize: {
            width: this.$refs.video.clientWidth,
            height: this.$refs.video.clientHeight
          },
          current: {
            x: 0,
            y: 0,
            z: 1,
            zooming: false,
            width: this.$refs.video.clientWidth,
            height: this.$refs.video.clientHeight
          },
          last: {
            x: 0,
            y: 0,
            z: 1
          },
          type: undefined,
          delta: {x: undefined, y: undefined}
        }

      }
    },
    countTap() {
      setTimeout(() => {
        this.countTap = 0
      }, 500)
      if (this.countTap === 2) {
        this.videoSet.current.z = 1
      }
    },
    isFullScreen() {
      if (this.isFullScreen) {
        document.addEventListener('fullscreenchange', this.changeFullScreen)
        document.addEventListener("webkitfullscreenchange", this.changeFullScreen);

        this.desktopZoomInstance = panzoom(this.$refs.videoContainer, {
          maxZoom: 7,
          minZoom: 1,
          bounds: true,
          boundsPadding: 1,
          zoomDoubleClickSpeed: 0
        },)

        this.desktopZoomInstance.on('zoom', () => {
          this.videoSet.current.z = this.desktopZoomInstance.getTransform().scale
          if (this.desktopZoomInstance.getTransform().scale <= 1){
            this.$refs.video.style.transform = null
          }
        });
      } else {
        document.removeEventListener('fullscreenchange', this.changeFullScreen)
        this.stop = false
        this.videoSet.current.z = 1

        this.desktopZoomInstance.dispose()

      }
    },

    video() {
      this.playVideo()

    },
    getShow() {
      this.playVideo()

    },
    getVolume() {
      const video = this.$refs.video
      if (this.volume === 0) {
        video.volume = 0
        this.isMuted = true
      } else {
        video.volume = this.volume
        this.isMuted = false
      }
    },
    stop(val) {
      const video = this.$refs.video
      if (val) {
        video.pause()
      } else {
        video.currentTime = this.hlsPlayer.liveSyncPosition
        video.play()
      }
    }
  },
  beforeDestroy() {
    if (this.isFullScreen){
      this.exitScreen()
    }

    if (this.hlsPlayer != null && !this.isIos) {
      this.hlsPlayer.detachMedia(this.$refs.video)
      this.hlsPlayer.destroy()
    } else {
      this.$refs.video.pause()
      this.$refs.video.removeAttribute('src') // empty source
      this.$refs.video.load()
    }
    window.removeEventListener('orientationchange', this.loadShow)
  }
}
</script>

<style scoped lang="scss">
.video {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #000;
  bottom: 0;
  &_bg {
    &::before {
      content: '';
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.224365) 50%, rgba(0, 0, 0, 0.0001) 100%);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 25%;
      z-index: 4;
      transition: all .25s;
      opacity: 1;
    }
    &::after {
      content: '';
      position: absolute;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
      bottom: 0;
      height: 25%;
      z-index: 4;
      transition: all .25s;
      opacity: 1;
      left: 0;
      right: 0;
    }
  }

  &__container{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: pan-x pan-y;

  }

  video {
    width: 100%;
    height: auto;
    z-index: 2;
  }

  &__loader {
    z-index: 4;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }

  &__title {
    font-size: 14px;
    font-family: Roboto, "sans-serif";
    font-weight: 100;
    letter-spacing: 0;
    line-height: 16px;
    position: absolute;
    left: 18px;
    top: 19px;
    color: white;
    z-index: 5;
  }

  &__item {
    //transition: all .25s;
    &_grab {
      cursor: grab;
    }

    &_translate {
      transition: all .25s;
    }

    &_fullscreen{

      @media screen and (orientation: landscape){
        width: 100%;
        height: auto !important;
      }

      @include media(992){
        @media screen and (orientation: landscape){
          height: 100%;
          width: auto !important;
        }

        @media screen and (orientation: portrait) {
          width: 100%;
          height: auto !important;
        }
      }
    }
  }

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    z-index: 4;
    color: #fff;
    transform: translateY(-50%) translateX(-50%);
    max-width: 300px;
    width: 100%;

    &::before {
      content: '';
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.224365) 14.52%, rgba(0, 0, 0, 0.0001) 26.35%, rgba(0, 0, 0, 0.0001) 75.63%, rgba(0, 0, 0, 0.5) 100%);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 4;
      transition: all .25s;
      opacity: 0;
    }

    span {
      max-width: 320px;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__info {
    opacity: 1;
    z-index: 5;
    transition: all .5s;

    &:hover {
      opacity: 1;
    }
  }

  &__archive {
    width: 24px;
    height: 15px;
    position: absolute;
    top: 16px;
    right: 22px;
    cursor: pointer;

    &.right {
      right: 60px;
    }

    z-index: 5;
  }

  &__fullscreen {
    right: 17px;
    bottom: 17px;
    position: absolute;
    z-index: 5;
    cursor: pointer;

    @include media(992){
      display: none;
    }
  }

  &__share {
    position: absolute;
    right: 22px;
    top: 16px;
    width: 19px;
    height: 17px;
    z-index: 5;

    &:hover {
      filter: brightness(80%);
    }
  }
}



.volume__icon{
  position: absolute;
  left: 17px;
  right: 0px;
  bottom: 17px;
  z-index: 5;
  cursor: pointer;

  &_disabled{
    opacity: .8;
    pointer-events: none;


      g {
        circle {
          fill: none;
        }
      }

  }


  @include media(992){
    right: 17px;
    bottom: 17px;
    left: auto;
  }
}

.watermark{
  font-family: Roboto, "sans-serif";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 1px;
  position: absolute;
  left: 17px;
  bottom: 17px;
  z-index: 3;

  color: rgba(255,255,255,.1);
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
}

</style>
